import { HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { throwError } from "rxjs";
import Swal, { SweetAlertIcon } from "sweetalert2";

function errorOrSuccessPopup(
  title: string,
  text: string,
  icon?: SweetAlertIcon,
  timer?: number,
) {
  return Swal.fire({
    icon: icon,
    iconColor: icon == "error" ? "#d31346" : "",
    title: title,
    text: text,
    showConfirmButton: timer ? false : true,
    focusConfirm: false,
    confirmButtonText: "OK",
    confirmButtonColor: "#d31346",
    timer: timer,
  });
}

function cloneDeep(val: any) {
  return JSON.parse(JSON.stringify(val));
}
function roundToOneDecimalPoint(num: any): any {
  return (Math.round(num * 10) / 10).toFixed(1);
}
function makeFalse(arr: any, i: any) {
  return arr.map((obj: any, index: any) => {
    if (index !== i) {
      obj.checked = false;
    }
    return obj;
  });
}
function isObject(val: any) {
  return val instanceof Object;
}
function getSelectedObjFilters(arr: any, name: any) {
  let ans = arr.filter((obj: any) => {
    return obj.name === name;
  });
  return ans.length ? ans[0] : [];
}

function getCheckedValues(arr: any) {
  let ans = arr.filter((obj: any) => {
    if (obj.checked) {
      return obj.value;
    }
  });
  return ans.map((val: any) => val.value);
}

function createObjectWithChecked(arr: any) {
  return arr.map((str: any) => {
    if (isObject(str)) {
      return str;
    }
    return {
      value: str,
      checked: false,
      disabled: false,
    };
  });
}

export function getHeaders() {
  return new HttpHeaders({
    "Content-Type": "application/json",
  });
}

export function handleResponse(response: any) {
  let response_;
  if (typeof response == "string") {
    response_ = JSON.parse(response);
  } else {
    response_ = response;
  }

  console.log("err", typeof response);
  if (response_.code === 200) {
    return response_.data;
  } else if (response_.code === 400) {
    console.log(response_.code);

    throw new Error(response_.data);
  }
  return response_;
}

export function handleError(error: HttpErrorResponse) {
  console.log("errormsg", error);

  if (error.status === 0) {
    // A client-side or network error occurred. Handle it accordingly.
    console.error("An error occurred:", error.error);
  } else if (error.status === 500) {
    console.log("error :: ", error);
    return throwError(error.statusText);
  } else if (error.status === 401) {
    let error_ = JSON.parse(error.error);
    return throwError(error_.err_msg);
  } else if (error.status === 400) {
    let error_ = JSON.parse(error.error);
    console.log("errormsg", error_);
    return throwError(error_);
  } else {
    // The backend returned an unsuccessful response code.
    // The response body may contain clues as to what went wrong.

    console.error("error :: ", error);
  }
  // Return an observable with a user-facing error message.
  return throwError(error.message);
}

export {
  errorOrSuccessPopup,
  cloneDeep,
  roundToOneDecimalPoint,
  getCheckedValues,
  createObjectWithChecked,
  getSelectedObjFilters,
  makeFalse,
};
